import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import CreateEventModal from './CreateEventModal';

export default class EventSection extends Component {
  static propTypes = {
    userEventsList: PropTypes.array.isRequired,
    selectedEvent: PropTypes.object,
    handleSelectEvent: PropTypes.func.isRequired,
    submitCreateEvent: PropTypes.func.isRequired
  };

  state = {
    eventModalIsOpen: false
  };

  openEventModal = () => {
    this.setState({ eventModalIsOpen: true });
  };

  closeEventModal = () => {
    this.setState({ eventModalIsOpen: false });
  };

  render () {
    const { userEventsList, selectedEvent, handleSelectEvent, submitCreateEvent } = this.props;
    const { eventModalIsOpen } = this.state;
    const options = userEventsList.map(event => ({
      label: event.name,
      value: event.id,
      data: event
    }));
    return (
      <div className='job-posting-section'>
        <header><h4>Event</h4></header>
        <Select
          onChange={handleSelectEvent}
          options={options}
          placeholder='Choose'
          value={selectedEvent}
        />
        <p className='mt-2'>
          Choose from list or
          <button className='additional-link non-button' onClick={this.openEventModal}>
            Create Another Event
          </button>
        </p>
        <CreateEventModal
          isOpen={eventModalIsOpen}
          closeModal={this.closeEventModal}
          submitCreateEvent={submitCreateEvent}
        />
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/ChooseEmployerEventStep/EventSection.js